// Predental Access Configuration
// Access is based on: UAS, coach status, active subscription, or lifetime plan email list

import { studentsLifetimePlan } from 'util/DataList';

// Predental has no free trial
export const isTrialValid = () => false;
export const getTrialDaysRemaining = () => 0;
export const isSubscriptionValid = () => false;

// Check if user has active access (UAS, coach, or lifetime plan)
export const hasActiveAccess = (userDetails) => {
  if (!userDetails) return false;

  if (userDetails.ultimateAdvisingStudent === true || userDetails.ultimateAdvisingStudent === "true") {
    return true;
  }

  if (userDetails.coach === true || userDetails.coach === "true") {
    return true;
  }

  if (userDetails.email && studentsLifetimePlan.includes(userDetails.email)) {
    return true;
  }

  // If user has an active subscription (subsId exists), consider them as having access
  // Full subscription validation is handled by the Plans component overlay
  if (userDetails.subsId) {
    return true;
  }

  return false;
};

// For predental, paid access is the same as active access (no free trial to distinguish)
export const hasPaidAccess = (userDetails) => hasActiveAccess(userDetails);
